import { render, staticRenderFns } from "./AddFurniture.vue?vue&type=template&id=dcdf4c90&scoped=true&"
import script from "./AddFurniture.vue?vue&type=script&lang=js&"
export * from "./AddFurniture.vue?vue&type=script&lang=js&"
import style0 from "./AddFurniture.vue?vue&type=style&index=0&id=dcdf4c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf4c90",
  null
  
)

export default component.exports